export const addresses = [
  {
    name: "Glasgow West End",
    address: "404 Byres Rd, Glasgow G12 8AS",
    phone: "+44 141 237 0200",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17355.967156327686!2d-4.313436563338672!3d55.883939316627206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x488845e4f71903f9%3A0xbc1a2ad9c74ffef6!2sChristies%20Cashmere!5e0!3m2!1sen!2suk!4v1763400884646!5m2!1sen!2suk",
  },
  {
    name: "Glasgow City",
    address: "34 Gordon St, Glasgow G1 3PU",
    phone: "+44 141 249 9857",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10393.105081474312!2d-4.287912308168237!3d55.8707332546518!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4888469e4f7df21b%3A0xe540bb95e94db1fa!2sHouse%20Of%20Cashmere%20Glasgow!5e0!3m2!1sen!2suk!4v1763400950874!5m2!1sen!2suk",
  },
  {
    name: "St Andrews",
    address: "157a South St, St Andrews KY16 9UP",
    phone: "+44 1334 208160",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2211.4420789293063!2d-2.7996012226216056!3d56.33945657330704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x488657bb7e0b1d1b%3A0xa25e20ca424e4c58!2sChristies%20Cashmere!5e0!3m2!1sen!2suk!4v1763401010619!5m2!1sen!2suk",
  },
];
